import Layers from "../../../assets/layers.png"
import Ticket from "../../../assets/ticket.png";
import Reports from "../../../assets/Reports.png";
import Home from "../../../assets/home.png";
import Tutorialicon from "../../../assets/tu.png";
import Hierarchy from "../../../assets/hierarchy.png";
import Console from "../../../assets/Console.png";
import Logout from "../../../assets/logout.png";
import WorkHistory from "../../../assets/suitcase.png";
import Subordinates from "../../../assets/subordinates.png";
import Todo from "../../../assets/todo.png";
import KPIIMG from "../../../assets/kpi_icon.png";
import Leave from "../../../assets/leave.png";
import meeting from "../../../assets/meeting.png";
import Approvals from "../../../assets/approval.png";
import subscriptionicon from "../../../assets/subscription_icon.png";
import Needhelpicon from "../../../assets/needhelp5.png";
import payrollicon from "../../../assets/salary.png";
import refericon from "../../../assets/refer_icon.png";
import BroadcastIcon from "../../../assets/announcement.png"
import { secureGet } from "../../../utility/secureStorage";
export const getSideBarDetails =(countnav,sessiondata,rawconfig)=>{
      console.log(rawconfig,"rawconfig")
      
const data=secureGet("rawconfig")
console.log(JSON.parse(data),"datat")
const getdisplay = (reduxValue, localValue) => {
  
  if (Object.keys(rawconfig || {}).length > 0) {
    console.log("heyreduxxxxx")
    return reduxValue;
  }else if(localRawConfig && Object.keys(localRawConfig).length > 0){
    console.log("heeyyyy localstorage")
  return localValue
  }else{
    console.log("normalllll")
    return 1
  }
};
const localRawConfig = JSON.parse(secureGet("rawconfig") || "{}");


  //     const getdisplay = (display) =>
  // Object.keys(rawconfig || {} ).length == 0 ? 1 : display;
      const sideBarDetails = [
      {
        name: "Home",
        icon: Home,
        targetPage: "home",
        redirect: 0,
        group: "Top",
        display: 1,
      },
      {
        name: "To-Do List",
        icon: Todo,
        targetPage: "todo",
        redirect: 0,
        group: "My Work",
        count: countnav[0]?.todocount,
        display: getdisplay(rawconfig?.showtodolist, localRawConfig?.showtodolist),
      },
      {
        name: "Activities",
        icon: Layers,
        targetPage: `activity`,
        redirect: 0,
        group: "My Work",
        count: countnav[0]?.activities,
        display: getdisplay(rawconfig?.showactivitylist,localRawConfig?.showactivitylist),
      },
      {
        name: "Tickets",
        icon: Ticket,
        targetPage: "tickets",
        redirect: 0,
        group: "My Work",
        count: countnav[0]?.pendingtickets,
        display: getdisplay(rawconfig?.showticketlist,localRawConfig?.showticketlist),
      },
      {
        name: "Meetings",
        icon: meeting,
        targetPage: "meetings",
        redirect: 0,
        group: "My Work",
        count: countnav[0]?.meetings,
        display: getdisplay(rawconfig?.showmeetinglist,localRawConfig?.showmeetinglist),
      },
      {
        name: "KPI Pendencies",
        icon: KPIIMG,
        targetPage: "kpipendency",
        redirect: 0,
        group: "My Work",
        count: countnav[0]?.kpipendencycount,
        display: getdisplay(rawconfig?.showkpilist,localRawConfig?.showkpilist),
      },
      {
        name: "Leaves",
        icon: Leave,
        targetPage: `leaves`,
        redirect: 0,
        group: "My Info",
        display: 1,
      },
      {
        name: "Subordinates",
        icon: Subordinates,
        targetPage: "subordinates",
        redirect: 0,
        group: "My Info",
        count: countnav[0]?.subordinates,
        display: 1,
      },
      {
        name: "Work History",
        icon: WorkHistory,
        targetPage: `workhistory`,
        redirect: 0,
        group: "My Info",
        display: 1,
      },
      {
        name: "My Payslips",
        icon: payrollicon,
        targetPage: `mypayslip`,
        redirect: 0,
        group: "My Info",
        display: sessiondata?.showmypayslips,
      },
      
       {
        name: "Approvals",
        icon: Approvals,
        targetPage: `approvals`,
        redirect: 0,
        group: "My Info",
        count: countnav[0]?.approvals,
        display: 1,
      },
     
      {
        name: "Broadcasts",
        icon: BroadcastIcon,
        targetPage: "broadcast",
        redirect: 0,
        group: "Organisation",
        display: 1,
      },
      {
        name: "Reports",
        icon: Reports,
        targetPage: "Report",
        redirect: 0,
        group: "Organisation",
        display: 1,
      },
       {
        name: "Hierarchy",
        icon: Hierarchy,
        targetPage: "Hierarchy",
        redirect: 0,
        group: "Organisation",
        display: 1,
      },
      {
        name: "Payroll",
        icon: payrollicon,
        targetPage: "payroll",
        redirect: 0,
        group: "Organisation",
        display: sessiondata?.showpayrollmodule,
      },
     
      {
        name: "Console",
        icon: Console,
        targetPage: "Console",
        redirect: 0,
        group: "Organisation",
        display: 1,
      },
      {
        name: "Logout",
        icon: Logout,
        targetPage: "none",
        redirect: 0,
        group: "Organisation",
        display: 1,
      },
      {
        name: "Refer Us",
        icon: refericon,
        targetPage: "referus",
        redirect: 0,
        group: "Plans & Perks",
        display: 1,
      },
      {
        name: "My Subscriptions",
        icon: subscriptionicon,
        targetPage: "mysubscriptions",
        redirect: 0,
        group: "Plans & Perks",
        display: sessiondata?.showsubscriptions,
      },

      {
        name: "Need Help?",
        icon: Needhelpicon,
        targetPage: "needhelp",
        redirect: 0,
        group: "About TrackHr",
        display: 1,
      },
      {
        name: "Tutorials",
        icon: Tutorialicon,
        targetPage: "tutorials",
        redirect: 0,
        group: "About TrackHr",
        display: 1,
      },
    ];
    return sideBarDetails
}